export default `
fragment BookSeriesFragment on book_series {
  bookId: book_id
  seriesId: series_id
  position
  details
  featured
}
`;
